import React from 'react';
import {View} from 'react-native';
import {ISousTitre} from '../../../../data/types/interface/infoAssurance';
import {formsStyles} from '../../Inputs/formStyles';
import Label from '../../Label';
import {InfoSousTitre} from './InfoSousTitre';
interface Props {
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  isVisible: boolean;
}
export const AssuranceInfo = ({isVisible, data}: Props) => {
  const form =
    data &&
    data.length > 0 &&
    data.map(
      (
        elt: {prime: string; titre: string; sousTitres: ISousTitre[]},
        i: React.Key | null | undefined,
      ) => {
        return (
          <View key={i} style={formsStyles.formGroup}>
            <Label title={elt.prime} type="secondTitle" />
            {elt.titre !== '' && <Label title={elt.titre} type="secondTitle" />}
            <InfoSousTitre datas={elt.sousTitres} />
          </View>
        );
      },
    );

  return <View>{isVisible && <View>{form}</View>}</View>;
};
